import * as z from "zod";

export const PricingTierSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be less than 255 characters")
    .trim(),
  description: z
    .string()
    .max(255, "Description must be less than 255 characters")
    .nullable()
    .optional(),
  is_default: z.boolean().default(false),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createPricingTierSchema = PricingTierSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updatePricingTierSchema = PricingTierSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
